import React from 'react';
import { ChakraProvider, CSSReset } from '@chakra-ui/react';
import { BrowserRouter as Router } from 'react-router-dom';
import { GameProvider } from './context/GameContext';
import { WordTrackerProvider } from './context/WordTrackerContext';
import AppRoutes from './routes';
import theme from './theme';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <CSSReset />
      <Router>
        <WordTrackerProvider>
          <GameProvider>
            <AppRoutes />
          </GameProvider>
        </WordTrackerProvider>
      </Router>
    </ChakraProvider>
  );
}

export default App;